import DiscordMarkdown from "@/components/markdown/DiscordMarkdown";
import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";

interface WelcomeModalProps {
    isOpen: boolean;
    closeModal: () => void;
    username: string;
    clanName: string;
}

const WelcomeModal: React.FC<WelcomeModalProps> = ({
    isOpen,
    closeModal,
    username,
    clanName,
}) => {
    const welcomeMessage = `Welcome to VANDERHEIM, **${username}**!
Thank you for forging your shield!

Through your actions in the village, your shield can earn value (SV) and renown.
Head to your profile to perform village tasks, view your statistics, track your progress, and see the full list of Shield Tags you can earn, like these:

:crossed_swords: TAG of TÝR — earn 10,000 Valor Points (VP)
:gem: TAG of FAFNIR — cheer 500 bits
:gift: TAG of GEFJUN — gift 10 subscriptions
:coin: TAG of SIF — spend 12,000 Favour of the Gods (channel points)
:postal_horn: TAG of HEIMDALL — 25 check-ins

Be sure to check the leaderboard to see how your clan (**${clanName}**) is faring in this season's Battle of Midgard.

See you in the Longhouse, Viking!

Skál :beers:`;

    return (
        <Transition show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-1000" onClose={closeModal}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="bg-brand_charcoal/80 fixed inset-0 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="bg-brand_charcoal border-brand relative z-1000 w-full transform overflow-hidden rounded-lg border-4 p-6 text-left shadow-xl transition-all sm:max-w-3xl">
                                <Dialog.Title className="text-brand font-prviking mb-4 text-center text-2xl font-bold">
                                    Skál!
                                </Dialog.Title>
                                <div className="text-brand whitespace-pre-line">
                                    <DiscordMarkdown>
                                        {welcomeMessage}
                                    </DiscordMarkdown>
                                </div>
                                <div className="mt-6 flex justify-center">
                                    <button
                                        onClick={closeModal}
                                        className="text-brand border-brand font-prviking rounded border-2 bg-blue-600 px-6 py-2 text-lg hover:bg-blue-700"
                                    >
                                        To Battle!
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};

export default WelcomeModal;
